import { inject, injectable } from "inversify";
import { Subscribable } from "knockout";
import { wccModules } from "../../../../enums/wccModules";
import { WCCAttachmentLayoutVMConfig } from "./base.interfaces";

@injectable()
export default class WCCAttachmentLayoutVM {
    url: Subscribable<string | undefined>
    title: Subscribable<string | undefined>
    quickSell: Subscribable<string | undefined>
    imageURL: Subscribable<string | undefined>
    icon: Subscribable<string | undefined>

    imageShown: Subscribable<boolean>
    iconShown: Subscribable<boolean>

    constructor(
        @inject(wccModules.componentConfig) config: WCCAttachmentLayoutVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {
        this.url = ko.flattenComputed(config.url);
        this.title = ko.flattenComputed(config.title);
        this.quickSell = ko.flattenComputed(config.quickSell);
        this.imageURL = ko.flattenComputed(config.imageURL);
        this.icon = ko.flattenComputed(config.icon);

        this.imageShown = this.imageURL.isNotNull();
        this.iconShown = ko.pureComputed(() => !this.imageShown() && this.icon() != undefined);

        const theme = ko.flattenComputed(config.theme, 'default');
        const ratio = ko.flattenComputed(config.ratio);

        const paddingTop = ratio.pluck(r => 100 / r);

        ko.applyBindingsToNode(info.element, {
            'style': {
                'padding-top': paddingTop.toPrts(true)
            },

            'css': {
                'wcc-attachment-layout': true,
                'wcc-attachment-layout--default': theme.is('default'),
                'wcc-attachment-layout--light': theme.is('light')
            }
        });
    }
}